var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"md-layout md-alignment-center-center",attrs:{"id":"page-not-found"}},[_c('div',[_c('md-icon',{staticClass:"md-size-5x"},[_vm._v("error_outline")]),_c('h1',[_vm._v("PAGE NOT FOUND")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }